import {
  ADD_USER_ADDRESS,
  REMOVE_USER_ADDRESS,
  REMOVE_USER_LOGIN_DATA,
  SET_USER_ADDRESSES,
  SET_USER_DATA,
  SET_USER_LOGIN_DATA,
  SHOW_ONBOARD,
  UPDATE_USER_ADDRESS,
} from "../actions/types";

const initialState = {
  loginData: {},
  showOnboard: true,
  userData: {},
  addresses: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ONBOARD: {
      return {
        ...state,
        showOnboard: false,
      };
    }
    case SET_USER_LOGIN_DATA: {
      return {
        ...state,
        loginData: action.data,
      };
    }
    case SET_USER_DATA: {
      return {
        ...state,
        userData: action.data,
      };
    }
    case REMOVE_USER_LOGIN_DATA: {
      return {
        ...state,
        loginData: {},
        userData: {},
        addresses: [],
      };
    }
    case SET_USER_ADDRESSES: {
      return {
        ...state,
        addresses: action.data,
      };
    }
    case ADD_USER_ADDRESS: {
      return {
        ...state,
        addresses: [action.data, ...state.addresses],
      };
    }
    case UPDATE_USER_ADDRESS: {
      let tempAddrs = [...state.addresses];
      tempAddrs[action.data.index] = action.data.data;
      return {
        ...state,
        addresses: [...tempAddrs],
      };
    }
    case REMOVE_USER_ADDRESS: {
      let tempAddrs = state.addresses.filter(
        (_, index) => index !== action.data
      );
      return {
        ...state,
        addresses: [...tempAddrs],
      };
    }
    default:
      return state;
  }
};

export default userReducer;
